module.exports = __webpack_public_path__ + "static/media/after.49d20f7c.png";